import { useMutation } from 'react-query'
import request from '../../../request'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useCheckFacebookCustomAudienceTOSSigned = () => {
  const dealership = useDealership()
  return useMutation(({ account_id }: { account_id: string }) =>
    request({
      url: `/agencies/${dealership?.organization_id}/dsp/accounts/facebook/${account_id}/tos_signed`,
      method: 'GET',
    }).then((res: any) => res.data),
  )
}
